import axios from 'axios'
import * as Util from '@/vuex/util'

const state = {
  list: [],
  options: {},
  active: false
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.list = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  SET_OPTIONS (state, options) {
    state.options = options
  },

  TOGGLE_ACTIVE (state) {
    state.active = !state.active
  },

  RESET (state) {
    state.list = []
    state.options = {}
    state.active = false
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  },

  setOptions: function ({commit}, options) {
    commit('SET_OPTIONS', options)
  },

  toggleActive: function ({commit}) {
    commit('TOGGLE_ACTIVE')
  }
}

const getters = {
  get: state => state.list,
  options: state => state.options,
  active: state => state.active,
  filters (state, getters, rootState) {
    return {
      startDate: rootState.filterDateRange.startDate,
      endDate: rootState.filterDateRange.endDate
    }
  }
}

export const FullListRank = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/trays/FullListRank.js